import { useQuery } from '@tanstack/react-query';
import { CommandInfo } from '../types';
import { listCommands } from './useChatApi';

export const QUERY_KEY_SLASH_COMMANDS = 'slashCommands';

export const FALLBACK_COMMANDS: CommandInfo[] = [
  { name: '/list-commands', description: 'List all available slash commands' },
  {
    name: '/list-commits',
    description: 'List configuration commits made in this chat',
  },
  { name: '/list-skills', description: 'List available agent skills' },
  { name: '/list-mcp-tools', description: 'List MCP tools by category' },
  { name: '/list-agent-tools', description: 'List built-in agent tools' },
];

export const getFilteredCommands = (
  commands: CommandInfo[],
  filter: string
): CommandInfo[] => {
  const normalizedFilter = filter.toLowerCase();
  return commands.filter(cmd =>
    cmd.name.toLowerCase().startsWith(normalizedFilter)
  );
};

export const useSlashCommands = ({ enabled }: { enabled?: boolean } = {}) => {
  const { data } = useQuery({
    queryKey: [QUERY_KEY_SLASH_COMMANDS] as const,
    queryFn: listCommands,
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  const commands = data && data.length > 0 ? data : FALLBACK_COMMANDS;

  return { commands };
};
